


















































































import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import container from "../../inversify.config";
import { formatService } from "../../services/format.service";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";

import Loader from "@/components/Loader.vue";

import ContentSetCreator from "@/components/contentset/ContentSetCreator.vue";

const ContentSetModule = namespace("contentSetModule");

@Component({
  components: {
    Loader,
    ContentSetCreator
  }
})
export default class ContentSetsTable extends Vue {
  @ContentSetModule.Action public retrieveContentSets;
  @ContentSetModule.Action public deleteContentSet;
  @ContentSetModule.Getter public contentSets;

  get getContentSets(): IContentSet[] {
    return this.contentSets;
  }

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  public filter: string | null = null;

  @Provide() public items: IContentSet[] = [];

  @Provide()
  public columns = [
    {
      key: "name",
      label: "Name",
      sortable: true,
      formatter: (value, key, item) => {
        return item;
      }
    },
    {
      key: "contentSetId",
      label: "Id",
      sortable: true
    },
    {
      key: "createdDate",
      label: "Created Date",
      sortable: true
    },
    {
      key: "properties.name",
      label: "Properties",
      formatter: (value, key, item) => {
        const properties = item.properties.map((x) => x.name);
        return formatService.commaSeparatedList(properties);
      }
    },
    {
      key: "contentTypes",
      label: "Content Types",
      formatter: (value, key, item) => {
        const contentTypes = item.contentTypes.map((x) => x.name);
        return formatService.commaSeparatedList(contentTypes);
      }
    },
    {
      key: "templateCount",
      label: "Templates"
    },
    {
      key: "state.name",
      label: "Status",
      sortable: true
    },
    {
      key: "actions",
      label: "Action",
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  private loading: boolean = true;

  private show: boolean = false;

  private selectedContentSet: IContentSet;

  public showModal(contentSet: IContentSet) {
    this.selectedContentSet = contentSet;
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

  public getRowCount(items) {
    return items.length;
  }

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  public updateContentSets() {
    this.loading = true;
    this.retrieveContentSets().then((result) => {
      this.items = this.getContentSets;
      this.loading = false;
    });
  }

  public onFiltered(filteredItems) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  public created() {
    this.updateContentSets();
  }

  private deleteSet() {
    if (this.selectedContentSet) {
      this.deleteContentSet(this.selectedContentSet).then((result) => {
        if (result) {
          this.updateContentSets();
          this.show = false;
        }
      });
    }
  }
}
